export default "__VITE_ASSET__KzF1jSIa__ 640w, __VITE_ASSET__DrnrG2cb__ 1024w, __VITE_ASSET__CuJh5UFi__ 1536w";